import AuthService from '@core/auth/services/AuthService';
import { HydrateOption } from '@core/enums';
import { ThemeWrapper } from '@helpers/theme';
import withRedux from '@helpers/withRedux';
import { withMotion } from '@hoc/withMotion';
import withWidget from '@hoc/withWidget';
import useBodyScrollLock from '@hooks/useBodyScrollLock';
import { ReactComponent as Phone } from '@img/icons/phone.svg';
import { ReactComponent as YSPShortLogo } from '@img/ysp/now-includes-ysp.svg';
import YourSolutionRootWidget from '@stories/Widgets/YourSolution/YS/YourSolutionRoot.widget';
import { AnimatePresence } from 'framer-motion';
import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconCtaList from './components/IconCtaList/IconCtaList';
import IconCtaListMobile from './components/IconCtaListMobile/IconCtaListMobile';
import Logo from './components/Logo/Logo';
import Navicon from './components/Navicon/Navicon';
import Navigation from './components/Navigation/Navigation';
import { NavigationDropdownMode, } from './components/Navigation/Navigation.types';
import NavigationMobile from './components/NavigationMobile/NavigationMobile';
import SearchField from './components/SearchField/SearchField';
import TopLinkList from './components/TopLinkList/TopLinkList';
import TopLinkListMobile from './components/TopLinkListMobile/TopLinkListMobile';
import { SiteHeaderStyles as S } from './SiteHeader.styles';
const SiteHeader = ({ logoCloudinaryPath, logoNavUrl, iconCtaListDesktop, iconCtaListMobile, isPortalHeader = false, searchResultsUrl, yourSolutionProps, showShortYourSolutionLogo = false, navigation = [], topLinks, telephoneNumber, translations, homeUrl, enquiriesCtaUrl, theme, }) => {
    const { isLoggedIn, welcomeMessage, myProfileUrl } = useSelector((x) => x.app);
    const [showNavigationMobile, setShowNavigationMobile] = useState(false);
    const [showSearchMobile, setShowSearchMobile] = useState(false);
    const [activeMobileNavigationId, setActiveMobileNavigationId] = useState('0');
    const [yspVisible, setYSPVisible] = useState(undefined);
    const dispatch = useDispatch();
    const lockRef = useBodyScrollLock(showNavigationMobile);
    React.useEffect(() => {
        // Not a great place for this logic but we need somewhere which will be on all pages, and also related to the enquiry basket
        // Fetch the enquiry basket stored in localstorage and merge it into the redux state, because you can't do it on page load
        // as it breaks SSR and it doesn't re-fire when hydrating client-side
        if (localStorage.getItem('ENQUIRY_BASKET') !== null &&
            localStorage.getItem('ENQUIRY_BASKET') !== undefined) {
            const enquiryBasket = JSON.parse(localStorage.getItem('ENQUIRY_BASKET'));
            dispatch({
                type: 'BASKET/SET_ENQUIRY_BASKET',
                payload: enquiryBasket,
            });
        }
    }, []);
    useBodyScrollLock(!!yspVisible);
    const handleSignOut = async () => {
        try {
            const res = await AuthService.signOut();
            if (!res.status.success) {
                return;
            }
            window.location.href = res.result.redirectUrl;
        }
        catch (error) {
            window.location.href = '/';
        }
    };
    const handleYsButtonClick = () => {
        setYSPVisible('ys');
    };
    const handleYspButtonClick = () => {
        setYSPVisible('ys+');
    };
    const top = (React.createElement(S.Top, { "data-has-top-links": topLinks && topLinks.length > 0 },
        React.createElement(S.TopInner, null,
            React.createElement(Navicon, { active: showNavigationMobile, onClick: () => {
                    setActiveMobileNavigationId('0');
                    setShowNavigationMobile(!showNavigationMobile);
                } }),
            React.createElement(Logo, { title: translations['gf.home'], url: logoNavUrl, logoCloudinaryPath: logoCloudinaryPath }),
            React.createElement(SearchField, { searchResultsUrl: searchResultsUrl, showSearchMobile: showSearchMobile, placeholderText: translations['gf.header.search.placeholder'], searchText: translations['gf.header.search'], closeText: translations['gf.header.close'], onClose: () => {
                    setShowSearchMobile(false);
                } }),
            React.createElement(IconCtaList, { items: iconCtaListDesktop, isLoggedIn: isLoggedIn, myProfileText: translations['gf.myprofile'], myProfileUrl: myProfileUrl, loginText: translations['gf.header.login'] }),
            React.createElement(IconCtaListMobile, { isLoggedIn: isLoggedIn, enquiriesCtaUrl: enquiriesCtaUrl, enquiriesText: translations['gf.header.enquiry'], searchText: translations['gf.header.search'], myProfileText: translations['gf.myprofile'], myProfileUrl: myProfileUrl, loginText: translations['gf.header.login'], onSearchClick: (event) => {
                    event.preventDefault();
                    setShowSearchMobile(!showSearchMobile);
                } }),
            topLinks && topLinks.length > 0 && React.createElement(TopLinkList, { items: topLinks }),
            welcomeMessage && (React.createElement(S.WelcomeMessageDesktop, null,
                React.createElement("span", null, welcomeMessage),
                React.createElement("a", { href: "#", onClick: (event) => {
                        event.preventDefault();
                        handleSignOut();
                    } }, translations['gf.header.signout']))))));
    const bottom = (React.createElement(S.Bottom, { active: showNavigationMobile, "data-show-short-logo": showShortYourSolutionLogo, "data-is-portal": isPortalHeader },
        React.createElement(S.BottomInner, null,
            React.createElement(Navigation, { items: navigation.filter((x) => !yourSolutionProps ? x.dropdown !== NavigationDropdownMode.YourSolution : true), homeUrl: homeUrl, isPortalHeader: isPortalHeader, onYsButtonClick: handleYsButtonClick, onYspButtonClick: handleYspButtonClick }),
            React.createElement(NavigationMobile, { activeId: activeMobileNavigationId, initial: true, items: navigation.filter((x) => !yourSolutionProps ? x.dropdown !== NavigationDropdownMode.YourSolution : true), isPortalHeader: isPortalHeader, onItemClick: (id) => {
                    setActiveMobileNavigationId(id);
                }, onYsButtonClick: handleYsButtonClick, onYspButtonClick: handleYspButtonClick }),
            activeMobileNavigationId === '0' && (React.createElement(Fragment, null,
                React.createElement(S.YspButtonWrapper, null, showShortYourSolutionLogo && (React.createElement(S.ShortLogo, null,
                    React.createElement(YSPShortLogo, null)))),
                React.createElement(IconCtaList, { items: iconCtaListMobile, isLoggedIn: isLoggedIn, myProfileText: translations['gf.myprofile'], myProfileUrl: myProfileUrl, loginText: translations['gf.header.login'] }),
                isLoggedIn && (React.createElement(S.WelcomeMessageMobile, null,
                    React.createElement("span", null, welcomeMessage),
                    React.createElement("a", { href: "#", onClick: (event) => {
                            event.preventDefault();
                            handleSignOut();
                        } }, translations['gf.header.signout']))),
                topLinks && topLinks.length > 0 && React.createElement(TopLinkListMobile, { items: topLinks }),
                !isPortalHeader && (React.createElement(S.Telephone, { href: `tel:${telephoneNumber}`, "aria-label": "Telephone Number" },
                    React.createElement(Phone, null),
                    React.createElement("p", null, telephoneNumber))))))));
    return (React.createElement(ThemeWrapper, { "data-theme": theme },
        React.createElement(S.Mobile, null, showNavigationMobile ? (React.createElement(S.Container, { isActive: true, ref: lockRef },
            top,
            bottom)) : (React.createElement(S.Container, { isActive: false }, top))),
        React.createElement(S.Desktop, null,
            React.createElement(S.Container, { isActive: false },
                top,
                bottom)),
        React.createElement(AnimatePresence, null, yourSolutionProps && yspVisible && (React.createElement(S.YourSolutionModal, { key: 'YourSolutionModal' },
            React.createElement(YourSolutionRootWidget, { ...yourSolutionProps, initialTab: yspVisible, closeModal: () => setYSPVisible(undefined) }))))));
};
export default withWidget(withRedux(withMotion(SiteHeader)), 'SiteHeader', {
    hydrate: HydrateOption.Always,
});
